<template>
    <div>
        <div class="main-wrapper">
            <button class="btn btn-close close">x</button>
            <img :src="`./countries/${countryName}.png`" class="country-badge">
            <h5 class="text-uppercase text-center">top campaigns</h5>
            <p v-for="(index, campaignName) in countryInfo" :key="campaignName">
                <img :src="`./badges/${index.area}.svg`" alt="">
                {{ campaignName}}
            </p>
            <div v-if="countryName == 'france' ">
                <a href="https://noscoupsdecoeur.kwanko.com/" target="_blank" class="cta text-uppercase text-center">see campaigns</a>
            </div>
            <div v-else>
                <a href="https://publisher.kwanko.com/#/postulation" target="_blank" class="cta text-uppercase text-center">see campaigns</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['countryInfo', 'countryName'],
    mounted() {
        document.querySelector('.cta').addEventListener('click', (e) => {
            e.stopPropagation();
        });
    },
};
</script>

<style lang="scss">
    @import '../assets/scss/landing/vars';

    .main-wrapper {
        position: relative;
        padding: 40px 60px;
        width: 330px;
        border-radius: 15px;
        background: #fff;
        color: #2f3338;

        .btn-close {
            position: absolute;
            top: 15px;
            right: 15px;
            margin: 0;
            padding: 0;
            font-weight: 400;
            font-size: 18px;
            line-height: 1;
        }
        .country-badge {
            position: absolute;
            top: 0;
            left: 50%;
            width: 60px;
            height: 60px;
            transform: translate(-50%, -50%);
        }
        h5 {
            margin-bottom: 30px;
            font-weight: 600;
            font-size: 20px;
        }
        p {
            display: flex;
            align-items: center;
            font-size: 16px;

            img {
                display: block;
                margin-right: 13px;
                width: 32px;
                height: 32px;
            }
        }
        a.cta {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 44px;
            border-radius: 25px;
            background-color: $kw-pink;
            color: #fff;
            font-weight: 600;
            transition: background-color .15s ease;

            &:hover {
                background-color: darken($kw-pink, 10%);
                text-decoration: none;
            }
        }
    }

</style>
